import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { SxProps, Theme } from '@mui/material';

const TeceoDragHandle = ({ sx }: { sx?: SxProps<Theme> }) => {
  return <DragIndicatorIcon className="ActionButton" sx={sx} />;
};

export default TeceoDragHandle;
